/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getProfilesAndStatusesForMembers = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(userIds, dispatch, getState) {
        var _getState$entities$us, currentUserId, profiles, statuses, profilesToLoad, statusesToLoad;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _getState$entities$us = getState().entities.users, currentUserId = _getState$entities$us.currentUserId, profiles = _getState$entities$us.profiles, statuses = _getState$entities$us.statuses;
                        profilesToLoad = [];
                        statusesToLoad = [];


                        userIds.forEach(function (userId) {
                            if (!profiles[userId] && !profilesToLoad.includes(userId) && userId !== currentUserId) {
                                profilesToLoad.push(userId);
                            }

                            if (!statuses[userId] && !statusesToLoad.includes(userId) && userId !== currentUserId) {
                                statusesToLoad.push(userId);
                            }
                        });

                        if (!profilesToLoad.length) {
                            _context.next = 7;
                            break;
                        }

                        _context.next = 7;
                        return (0, _users.getProfilesByIds)(profilesToLoad)(dispatch, getState);

                    case 7:
                        if (!statusesToLoad.length) {
                            _context.next = 10;
                            break;
                        }

                        _context.next = 10;
                        return (0, _users.getStatusesByIds)(statusesToLoad)(dispatch, getState);

                    case 10:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getProfilesAndStatusesForMembers(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

exports.selectTeam = selectTeam;
exports.getMyTeams = getMyTeams;
exports.getMyTeamUnreads = getMyTeamUnreads;
exports.getTeam = getTeam;
exports.getTeams = getTeams;
exports.createTeam = createTeam;
exports.updateTeam = updateTeam;
exports.getMyTeamMembers = getMyTeamMembers;
exports.getTeamMember = getTeamMember;
exports.getTeamMembersByIds = getTeamMembersByIds;
exports.getTeamsForUser = getTeamsForUser;
exports.getTeamMembersForUser = getTeamMembersForUser;
exports.getTeamStats = getTeamStats;
exports.addUserToTeam = addUserToTeam;
exports.addUsersToTeam = addUsersToTeam;
exports.removeUserFromTeam = removeUserFromTeam;
exports.updateTeamMemberRoles = updateTeamMemberRoles;
exports.sendEmailInvitesToTeam = sendEmailInvitesToTeam;
exports.checkIfTeamExists = checkIfTeamExists;
exports.joinTeam = joinTeam;

var _reduxBatchedActions = require('redux-batched-actions');

var _client = require('../client');

var _constants = require('../constants');

var _action_types = require('../action_types');

var _errors = require('./errors');

var _helpers = require('./helpers');

var _users = require('./users');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function selectTeam(team) {
    var _this = this;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            return _context2.abrupt('return', dispatch({
                                type: _action_types.TeamTypes.SELECT_TEAM,
                                data: team.id
                            }, getState));

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this);
        }));

        return function (_x4, _x5) {
            return _ref2.apply(this, arguments);
        };
    }();
}

function getMyTeams() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getMyTeams, _action_types.TeamTypes.MY_TEAMS_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAMS_LIST, _action_types.TeamTypes.MY_TEAMS_SUCCESS], _action_types.TeamTypes.MY_TEAMS_FAILURE);
}

function getMyTeamUnreads() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getMyTeamUnreads, _action_types.TeamTypes.MY_TEAM_UNREADS_REQUEST, [_action_types.TeamTypes.RECEIVED_MY_TEAM_UNREADS, _action_types.TeamTypes.MY_TEAM_UNREADS_SUCCESS], _action_types.TeamTypes.MY_TEAM_UNREADS_FAILURE);
}

function getTeam(teamId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getTeam, _action_types.TeamTypes.GET_TEAM_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAM, _action_types.TeamTypes.GET_TEAM_SUCCESS], _action_types.TeamTypes.GET_TEAM_FAILURE, teamId);
}

function getTeams() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.TEAMS_CHUNK_SIZE;

    return (0, _helpers.bindClientFunc)(_client.Client4.getTeams, _action_types.TeamTypes.GET_TEAMS_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAMS_LIST, _action_types.TeamTypes.GET_TEAMS_SUCCESS], _action_types.TeamTypes.GET_TEAMS_FAILURE, page, perPage);
}

function createTeam(team) {
    var _this2 = this;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var created, member;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.CREATE_TEAM_REQUEST }, getState);

                            created = void 0;
                            _context3.prev = 2;
                            _context3.next = 5;
                            return _client.Client4.createTeam(team);

                        case 5:
                            created = _context3.sent;
                            _context3.next = 13;
                            break;

                        case 8:
                            _context3.prev = 8;
                            _context3.t0 = _context3['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context3.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.CREATE_TEAM_FAILURE, error: _context3.t0 }, (0, _errors.getLogErrorAction)(_context3.t0)]), getState);
                            return _context3.abrupt('return', null);

                        case 13:
                            member = {
                                team_id: created.id,
                                user_id: getState().entities.users.currentUserId,
                                roles: _constants.General.TEAM_ADMIN_ROLE + ' ' + _constants.General.TEAM_USER_ROLE,
                                delete_at: 0,
                                msg_count: 0,
                                mention_count: 0
                            };


                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.TeamTypes.CREATED_TEAM,
                                data: created
                            }, {
                                type: _action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBER,
                                data: member
                            }, {
                                type: _action_types.TeamTypes.SELECT_TEAM,
                                data: created.id
                            }, {
                                type: _action_types.TeamTypes.CREATE_TEAM_SUCCESS
                            }]), getState);

                            return _context3.abrupt('return', created);

                        case 16:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this2, [[2, 8]]);
        }));

        return function (_x8, _x9) {
            return _ref3.apply(this, arguments);
        };
    }();
}

function updateTeam(team) {
    return (0, _helpers.bindClientFunc)(_client.Client4.updateTeam, _action_types.TeamTypes.UPDATE_TEAM_REQUEST, [_action_types.TeamTypes.UPDATED_TEAM, _action_types.TeamTypes.UPDATE_TEAM_SUCCESS], _action_types.TeamTypes.UPDATE_TEAM_FAILURE, team);
}

function getMyTeamMembers() {
    return (0, _helpers.bindClientFunc)(_client.Client4.getMyTeamMembers, _action_types.TeamTypes.MY_TEAM_MEMBERS_REQUEST, [_action_types.TeamTypes.RECEIVED_MY_TEAM_MEMBERS, _action_types.TeamTypes.MY_TEAM_MEMBERS_SUCCESS], _action_types.TeamTypes.MY_TEAM_MEMBERS_FAILURE);
}

function getTeamMember(teamId, userId) {
    var _this3 = this;

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
            var member;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.TEAM_MEMBERS_REQUEST }, getState);

                            member = void 0;
                            _context4.prev = 2;
                            _context4.next = 5;
                            return _client.Client4.getTeamMember(teamId, userId);

                        case 5:
                            member = _context4.sent;

                            getProfilesAndStatusesForMembers([userId], dispatch, getState);
                            _context4.next = 14;
                            break;

                        case 9:
                            _context4.prev = 9;
                            _context4.t0 = _context4['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context4.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.TEAM_MEMBERS_FAILURE, error: _context4.t0 }, (0, _errors.getLogErrorAction)(_context4.t0)]), getState);
                            return _context4.abrupt('return', null);

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                                data: [member]
                            }, {
                                type: _action_types.TeamTypes.TEAM_MEMBERS_SUCCESS
                            }]), getState);

                            return _context4.abrupt('return', member);

                        case 16:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this3, [[2, 9]]);
        }));

        return function (_x10, _x11) {
            return _ref4.apply(this, arguments);
        };
    }();
}

function getTeamMembersByIds(teamId, userIds) {
    var _this4 = this;

    return function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            var members;
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.TEAM_MEMBERS_REQUEST }, getState);

                            members = void 0;
                            _context5.prev = 2;
                            _context5.next = 5;
                            return _client.Client4.getTeamMembersByIds(teamId, userIds);

                        case 5:
                            members = _context5.sent;

                            getProfilesAndStatusesForMembers(userIds, dispatch, getState);
                            _context5.next = 14;
                            break;

                        case 9:
                            _context5.prev = 9;
                            _context5.t0 = _context5['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context5.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.TEAM_MEMBERS_FAILURE, error: _context5.t0 }, (0, _errors.getLogErrorAction)(_context5.t0)]), getState);
                            return _context5.abrupt('return', null);

                        case 14:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                                data: members
                            }, {
                                type: _action_types.TeamTypes.TEAM_MEMBERS_SUCCESS
                            }]), getState);

                            return _context5.abrupt('return', members);

                        case 16:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this4, [[2, 9]]);
        }));

        return function (_x12, _x13) {
            return _ref5.apply(this, arguments);
        };
    }();
}

function getTeamsForUser(userId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getTeamsForUser, _action_types.TeamTypes.GET_TEAMS_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAMS_LIST, _action_types.TeamTypes.GET_TEAMS_SUCCESS], _action_types.TeamTypes.GET_TEAMS_FAILURE, userId);
}

function getTeamMembersForUser(userId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getTeamMembersForUser, _action_types.TeamTypes.TEAM_MEMBERS_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAM_MEMBERS, _action_types.TeamTypes.TEAM_MEMBERS_SUCCESS], _action_types.TeamTypes.TEAM_MEMBERS_FAILURE, userId);
}

function getTeamStats(teamId) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getTeamStats, _action_types.TeamTypes.TEAM_STATS_REQUEST, [_action_types.TeamTypes.RECEIVED_TEAM_STATS, _action_types.TeamTypes.TEAM_STATS_SUCCESS], _action_types.TeamTypes.TEAM_STATS_FAILURE, teamId);
}

function addUserToTeam(teamId, userId) {
    var _this5 = this;

    return function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
            var member;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_REQUEST }, getState);

                            member = void 0;
                            _context6.prev = 2;
                            _context6.next = 5;
                            return _client.Client4.addToTeam(teamId, userId);

                        case 5:
                            member = _context6.sent;
                            _context6.next = 13;
                            break;

                        case 8:
                            _context6.prev = 8;
                            _context6.t0 = _context6['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context6.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_FAILURE, error: _context6.t0 }, (0, _errors.getLogErrorAction)(_context6.t0)]), getState);
                            return _context6.abrupt('return', null);

                        case 13:

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILE_IN_TEAM,
                                data: { user_id: userId },
                                id: teamId
                            }, {
                                type: _action_types.TeamTypes.RECEIVED_MEMBER_IN_TEAM,
                                data: member
                            }, {
                                type: _action_types.TeamTypes.ADD_TEAM_MEMBER_SUCCESS
                            }]), getState);

                            return _context6.abrupt('return', true);

                        case 15:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this5, [[2, 8]]);
        }));

        return function (_x14, _x15) {
            return _ref6.apply(this, arguments);
        };
    }();
}

function addUsersToTeam(teamId, userIds) {
    var _this6 = this;

    return function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState) {
            var members, profiles;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_REQUEST }, getState);

                            members = void 0;
                            _context7.prev = 2;
                            _context7.next = 5;
                            return _client.Client4.addUsersToTeam(teamId, userIds);

                        case 5:
                            members = _context7.sent;
                            _context7.next = 13;
                            break;

                        case 8:
                            _context7.prev = 8;
                            _context7.t0 = _context7['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context7.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_FAILURE, error: _context7.t0 }, (0, _errors.getLogErrorAction)(_context7.t0)]), getState);
                            return _context7.abrupt('return', null);

                        case 13:
                            profiles = [];

                            members.forEach(function (m) {
                                return profiles.push({ id: m.user_id });
                            });

                            dispatch((0, _reduxBatchedActions.batchActions)([{
                                type: _action_types.UserTypes.RECEIVED_PROFILES_LIST_IN_TEAM,
                                data: profiles,
                                id: teamId
                            }, {
                                type: _action_types.TeamTypes.RECEIVED_MEMBERS_IN_TEAM,
                                data: members
                            }, {
                                type: _action_types.TeamTypes.ADD_TEAM_MEMBER_SUCCESS
                            }]), getState);

                            return _context7.abrupt('return', members);

                        case 17:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this6, [[2, 8]]);
        }));

        return function (_x16, _x17) {
            return _ref7.apply(this, arguments);
        };
    }();
}

function removeUserFromTeam(teamId, userId) {
    var _this7 = this;

    return function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch, getState) {
            var member, actions, state, currentUserId, _state$entities$chann, channels, myMembers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, channelMember, channel;

            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.REMOVE_TEAM_MEMBER_REQUEST }, getState);

                            _context8.prev = 1;
                            _context8.next = 4;
                            return _client.Client4.removeFromTeam(teamId, userId);

                        case 4:
                            _context8.next = 11;
                            break;

                        case 6:
                            _context8.prev = 6;
                            _context8.t0 = _context8['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context8.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.REMOVE_TEAM_MEMBER_FAILURE, error: _context8.t0 }, (0, _errors.getLogErrorAction)(_context8.t0)]), getState);
                            return _context8.abrupt('return', null);

                        case 11:
                            member = {
                                team_id: teamId,
                                user_id: userId
                            };
                            actions = [{
                                type: _action_types.UserTypes.RECEIVED_PROFILE_NOT_IN_TEAM,
                                data: { user_id: userId },
                                id: teamId
                            }, {
                                type: _action_types.TeamTypes.REMOVE_MEMBER_FROM_TEAM,
                                data: member
                            }, {
                                type: _action_types.TeamTypes.REMOVE_TEAM_MEMBER_SUCCESS
                            }];
                            state = getState();
                            currentUserId = state.entities.users.currentUserId;

                            if (!(currentUserId === userId)) {
                                _context8.next = 36;
                                break;
                            }

                            _state$entities$chann = state.entities.channels, channels = _state$entities$chann.channels, myMembers = _state$entities$chann.myMembers;
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context8.prev = 20;


                            for (_iterator = Object.values(myMembers)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                channelMember = _step.value;
                                channel = channels[channelMember.channel_id];

                                if (channel && channel.team_id === teamId) {
                                    actions.push({
                                        type: _action_types.ChannelTypes.LEAVE_CHANNEL,
                                        data: channel
                                    });
                                }
                            }
                            _context8.next = 28;
                            break;

                        case 24:
                            _context8.prev = 24;
                            _context8.t1 = _context8['catch'](20);
                            _didIteratorError = true;
                            _iteratorError = _context8.t1;

                        case 28:
                            _context8.prev = 28;
                            _context8.prev = 29;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 31:
                            _context8.prev = 31;

                            if (!_didIteratorError) {
                                _context8.next = 34;
                                break;
                            }

                            throw _iteratorError;

                        case 34:
                            return _context8.finish(31);

                        case 35:
                            return _context8.finish(28);

                        case 36:

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context8.abrupt('return', true);

                        case 38:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this7, [[1, 6], [20, 24, 28, 36], [29,, 31, 35]]);
        }));

        return function (_x18, _x19) {
            return _ref8.apply(this, arguments);
        };
    }();
}

function updateTeamMemberRoles(teamId, userId, roles) {
    var _this8 = this;

    return function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(dispatch, getState) {
            var actions, membersInTeam;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.UPDATE_TEAM_MEMBER_REQUEST }, getState);

                            _context9.prev = 1;
                            _context9.next = 4;
                            return _client.Client4.updateTeamMemberRoles(teamId, userId, roles);

                        case 4:
                            _context9.next = 11;
                            break;

                        case 6:
                            _context9.prev = 6;
                            _context9.t0 = _context9['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context9.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.UPDATE_TEAM_MEMBER_FAILURE, error: _context9.t0 }, (0, _errors.getLogErrorAction)(_context9.t0)]), getState);
                            return _context9.abrupt('return', null);

                        case 11:
                            actions = [{
                                type: _action_types.TeamTypes.UPDATE_TEAM_MEMBER_SUCCESS
                            }];
                            membersInTeam = getState().entities.teams.membersInTeam[teamId];

                            if (membersInTeam && membersInTeam[userId]) {
                                actions.push({
                                    type: _action_types.TeamTypes.RECEIVED_MEMBER_IN_TEAM,
                                    data: _extends({}, membersInTeam[userId], { roles: roles })
                                });
                            }

                            dispatch((0, _reduxBatchedActions.batchActions)(actions), getState);

                            return _context9.abrupt('return', true);

                        case 16:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this8, [[1, 6]]);
        }));

        return function (_x20, _x21) {
            return _ref9.apply(this, arguments);
        };
    }();
}

function sendEmailInvitesToTeam(teamId, emails) {
    return (0, _helpers.bindClientFunc)(_client.Client4.sendEmailInvitesToTeam, _action_types.TeamTypes.TEAM_EMAIL_INVITE_REQUEST, [_action_types.TeamTypes.TEAM_EMAIL_INVITE_SUCCESS], _action_types.TeamTypes.TEAM_EMAIL_INVITE_FAILURE, teamId, emails);
}

function checkIfTeamExists(teamName) {
    var _this9 = this;

    return function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(dispatch, getState) {
            var data;
            return regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.GET_TEAM_REQUEST }, getState);

                            data = void 0;
                            _context10.prev = 2;
                            _context10.next = 5;
                            return _client.Client4.checkIfTeamExists(teamName);

                        case 5:
                            data = _context10.sent;
                            _context10.next = 13;
                            break;

                        case 8:
                            _context10.prev = 8;
                            _context10.t0 = _context10['catch'](2);

                            (0, _helpers.forceLogoutIfNecessary)(_context10.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.GET_TEAM_FAILURE, error: _context10.t0 }, (0, _errors.getLogErrorAction)(_context10.t0)]));
                            return _context10.abrupt('return', null);

                        case 13:

                            dispatch({ type: _action_types.TeamTypes.GET_TEAM_SUCCESS });

                            return _context10.abrupt('return', data.exists);

                        case 15:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this9, [[2, 8]]);
        }));

        return function (_x22, _x23) {
            return _ref10.apply(this, arguments);
        };
    }();
}

function joinTeam(inviteId, teamId) {
    var _this10 = this;

    return function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(dispatch, getState) {
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            dispatch({ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_REQUEST }, getState);

                            _context11.prev = 1;
                            _context11.next = 4;
                            return _client.Client4.joinTeam(inviteId, teamId);

                        case 4:
                            _context11.next = 11;
                            break;

                        case 6:
                            _context11.prev = 6;
                            _context11.t0 = _context11['catch'](1);

                            (0, _helpers.forceLogoutIfNecessary)(_context11.t0, dispatch);
                            dispatch((0, _reduxBatchedActions.batchActions)([{ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_FAILURE, error: _context11.t0 }, (0, _errors.getLogErrorAction)(_context11.t0)]), getState);
                            return _context11.abrupt('return', null);

                        case 11:
                            _context11.next = 13;
                            return getTeam(teamId)(dispatch, getState);

                        case 13:
                            _context11.next = 15;
                            return getMyTeamMembers()(dispatch, getState);

                        case 15:
                            getMyTeamUnreads()(dispatch, getState);

                            dispatch({ type: _action_types.TeamTypes.ADD_TEAM_MEMBER_SUCCESS }, getState);
                            return _context11.abrupt('return', true);

                        case 18:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this10, [[1, 6]]);
        }));

        return function (_x24, _x25) {
            return _ref11.apply(this, arguments);
        };
    }();
}



//////////////////
// WEBPACK FOOTER
// ./~/mattermost-redux/actions/teams.js
// module id = 205
// module chunks = 60